const CLAMP_QC_JOB_SKUS = new Set(["90-002-TLA", "90-003-TLA", "90-002-QC", "90-003-QC"]);

export function isClampQcJobSku(sku: string | null | undefined): boolean {
  return CLAMP_QC_JOB_SKUS.has((sku ?? "").trim().toUpperCase());
}

export const CLAMP_QC_RECEIVE_HOVER_HINT =
  "Receiving for clamp QC work orders is controlled from the Clamp QC page.";
export const CLAMP_QC_STARTED_HOVER_HINT =
  "Work order has been picked or inspected; manage it from the Clamp QC page.";
export const CLAMP_QC_RETURN_HOVER_HINT =
  "Return allocated material for clamp QC work orders from Close short on the Clamp QC page.";
export const HUB_NATIVE_QUANTITY_LOCKED_HINT =
  "Ordered quantity cannot change after this work order is picked, allocated, inspected, or received.";

export function clampQcJobStartedFromBom(
  bom: Array<{ quantityAllocated?: number | null; quantityConsumed?: number | null }> | null | undefined,
): boolean {
  return (bom ?? []).some(
    (line) => Math.round(Number(line.quantityAllocated ?? 0)) > 0 || Math.round(Number(line.quantityConsumed ?? 0)) > 0,
  );
}
